<script>
	import { hero_expanded, visits } from './../stores.js'
  import Title from '../elements/Title.svelte'
</script>

{#if $hero_expanded}
  <div class="HeroTitle">
    <Title on_fill=true>
      <span class="title">
        {#if !visits.first()}
          Good to see you back!<br>Let's get started...
        {:else}
          <span class="app_name">Wordmark &nbsp;</span>helps you choose fonts <br>for your creative projects
        {/if}
      </span>
    </Title>
  </div>
{/if}

<style>
  .HeroTitle {
    z-index: 1;
    position: absolute;
    top: 18vh;
  }
  .app_name {
    display: none;
  }
  .title {
    display: block;
  }
  .title::first-letter {
    text-transform: uppercase;
  }

  @media only screen and (max-width: 660px) {
    .app_name,
    .title {
      display: inline-block;
    }
    .title::first-letter {
      text-transform: none;
    }
		br {
			display: none;
		}
    .HeroTitle {
      width: Calc(100% - 8rem);
    }
	}
</style>